/**
 * ScrollProgress — thin terracotta line pinned to the top of the viewport
 * that fills left→right as the user scrolls the page. Uses framer-motion's
 * `useScroll` (0→1 normalized) piped through `useSpring` so it feels buttery
 * next to Lenis smooth-scroll instead of janky-tight.
 */
import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress({ color = "#D36135", height = 3 }) {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 25,
    mass: 0.4,
    restDelta: 0.001,
  });
  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress-bar"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height,
        background: color,
        transformOrigin: "0% 50%",
        scaleX,
        zIndex: 60,
        pointerEvents: "none",
      }}
    />
  );
}
